import MuiAvatar from "@mui/material/Avatar";

import { colors } from "@dotnet/telematics-design-system";

interface IAvatarProps {
  textToCut: string;
  customStyle?: any;
}

const Avatar = ({ textToCut, customStyle }: IAvatarProps) => {
  const avatarLetter = textToCut?.charAt(0).toUpperCase();

  return (
    <MuiAvatar
      data-testid="avatar"
      sx={[
        {
          color: colors.blue700,
          background: colors.blue100,
          fontSize: "14px",
          fontWeight: "600",
          lineHeight: "20px",
          letterSpacing: "0.1px",
          width: "24px",
          height: "24px"
        },
        customStyle
      ]}
    >
      {avatarLetter}
    </MuiAvatar>
  );
};

export default Avatar;
